module.exports = __webpack_public_path__ + "img/arrow_right_disabled.f7e35556.svg";